export const removeFirstCase = (cases: any) =>
  Object.fromEntries(
    Object.entries(cases)
      .filter((_, index) => index !== 0)
      .map(([, value], index) => [index, value])
  )

export const hasNonprofitWebsite = (website?: string | null): boolean =>
  website != null && website.trim() !== ''
